import classes from './ChooseOptionModal.module.css';

const ChooseOptionModal = ({ onClose }) => {
  return (
    <div className={classes.error_main}>
      <div className={classes.error_message}>You need to choose options for your item.</div>
      <div
        className={classes.close_error}
        onClick={onClose}
      >
        ×
      </div>
    </div>
  );
};

export default ChooseOptionModal;
